import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './styles.css';

interface IModalWrapper {
  onClose: VoidFunction;
  children: React.ReactNode;
}

export const ModalWrapper: React.FC<IModalWrapper> = ({ children, onClose }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['header']}>
        <div className={styles['icon']} onClick={onClose}>
          <IconActionClose16 />
        </div>
      </div>
      {children}
    </div>
  );
};
